/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AggregateKeyInfo } from './AggregateKeyInfo';
import {
    AggregateKeyInfoFromJSON,
    AggregateKeyInfoFromJSONTyped,
    AggregateKeyInfoToJSON,
} from './AggregateKeyInfo';
import type { ESearchStatutInscriptionListSearch } from './ESearchStatutInscriptionListSearch';
import {
    ESearchStatutInscriptionListSearchFromJSON,
    ESearchStatutInscriptionListSearchFromJSONTyped,
    ESearchStatutInscriptionListSearchToJSON,
} from './ESearchStatutInscriptionListSearch';
import type { FilterTextSearch } from './FilterTextSearch';
import {
    FilterTextSearchFromJSON,
    FilterTextSearchFromJSONTyped,
    FilterTextSearchToJSON,
} from './FilterTextSearch';
import type { NumericSearch } from './NumericSearch';
import {
    NumericSearchFromJSON,
    NumericSearchFromJSONTyped,
    NumericSearchToJSON,
} from './NumericSearch';
import type { StringListSearch } from './StringListSearch';
import {
    StringListSearchFromJSON,
    StringListSearchFromJSONTyped,
    StringListSearchToJSON,
} from './StringListSearch';
import type { TextSearch } from './TextSearch';
import {
    TextSearchFromJSON,
    TextSearchFromJSONTyped,
    TextSearchToJSON,
} from './TextSearch';

/**
 * 
 * @export
 * @interface ApprenantSearch
 */
export interface ApprenantSearch {
    /**
     * 
     * @type {TextSearch}
     * @memberof ApprenantSearch
     */
    nomSa?: TextSearch;
    /**
     * 
     * @type {TextSearch}
     * @memberof ApprenantSearch
     */
    prenomSa?: TextSearch;
    /**
     * 
     * @type {TextSearch}
     * @memberof ApprenantSearch
     */
    anneeScolaireCriteria?: TextSearch;
    /**
     * 
     * @type {TextSearch}
     * @memberof ApprenantSearch
     */
    telephone?: TextSearch;
    /**
     * 
     * @type {TextSearch}
     * @memberof ApprenantSearch
     */
    gsm?: TextSearch;
    /**
     * 
     * @type {FilterTextSearch}
     * @memberof ApprenantSearch
     */
    classeCriteria?: FilterTextSearch;
    /**
     * 
     * @type {NumericSearch}
     * @memberof ApprenantSearch
     */
    idapprenant?: NumericSearch;
    /**
     * 
     * @type {StringListSearch}
     * @memberof ApprenantSearch
     */
    centreCriteria?: StringListSearch;
    /**
     * 
     * @type {ESearchStatutInscriptionListSearch}
     * @memberof ApprenantSearch
     */
    statutInscription?: ESearchStatutInscriptionListSearch;
    /**
     * 
     * @type {Array<string>}
     * @memberof ApprenantSearch
     */
    sortKey?: Array<string> | null;
    /**
     * 
     * @type {Array<AggregateKeyInfo>}
     * @memberof ApprenantSearch
     */
    aggregateKeys?: Array<AggregateKeyInfo> | null;
    /**
     * 
     * @type {number}
     * @memberof ApprenantSearch
     */
    forceSkip?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ApprenantSearch
     */
    forceTake?: number | null;
    /**
     * 
     * @type {any}
     * @memberof ApprenantSearch
     */
    parameters?: any | null;
    /**
     * 
     * @type {string}
     * @memberof ApprenantSearch
     */
    filter?: string | null;
}

/**
 * Check if a given object implements the ApprenantSearch interface.
 */
export function instanceOfApprenantSearch(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ApprenantSearchFromJSON(json: any): ApprenantSearch {
    return ApprenantSearchFromJSONTyped(json, false);
}

export function ApprenantSearchFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApprenantSearch {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'nomSa': !exists(json, 'nomSa') ? undefined : TextSearchFromJSON(json['nomSa']),
        'prenomSa': !exists(json, 'prenomSa') ? undefined : TextSearchFromJSON(json['prenomSa']),
        'anneeScolaireCriteria': !exists(json, 'anneeScolaireCriteria') ? undefined : TextSearchFromJSON(json['anneeScolaireCriteria']),
        'telephone': !exists(json, 'telephone') ? undefined : TextSearchFromJSON(json['telephone']),
        'gsm': !exists(json, 'gsm') ? undefined : TextSearchFromJSON(json['gsm']),
        'classeCriteria': !exists(json, 'classeCriteria') ? undefined : FilterTextSearchFromJSON(json['classeCriteria']),
        'idapprenant': !exists(json, 'idapprenant') ? undefined : NumericSearchFromJSON(json['idapprenant']),
        'centreCriteria': !exists(json, 'centreCriteria') ? undefined : StringListSearchFromJSON(json['centreCriteria']),
        'statutInscription': !exists(json, 'statutInscription') ? undefined : ESearchStatutInscriptionListSearchFromJSON(json['statutInscription']),
        'sortKey': !exists(json, 'sortKey') ? undefined : json['sortKey'],
        'aggregateKeys': !exists(json, 'aggregateKeys') ? undefined : (json['aggregateKeys'] === null ? null : (json['aggregateKeys'] as Array<any>).map(AggregateKeyInfoFromJSON)),
        'forceSkip': !exists(json, 'forceSkip') ? undefined : json['forceSkip'],
        'forceTake': !exists(json, 'forceTake') ? undefined : json['forceTake'],
        'parameters': !exists(json, 'parameters') ? undefined : json['parameters'],
        'filter': !exists(json, 'filter') ? undefined : json['filter'],
    };
}

export function ApprenantSearchToJSON(value?: ApprenantSearch | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'nomSa': TextSearchToJSON(value.nomSa),
        'prenomSa': TextSearchToJSON(value.prenomSa),
        'anneeScolaireCriteria': TextSearchToJSON(value.anneeScolaireCriteria),
        'telephone': TextSearchToJSON(value.telephone),
        'gsm': TextSearchToJSON(value.gsm),
        'classeCriteria': FilterTextSearchToJSON(value.classeCriteria),
        'idapprenant': NumericSearchToJSON(value.idapprenant),
        'centreCriteria': StringListSearchToJSON(value.centreCriteria),
        'statutInscription': ESearchStatutInscriptionListSearchToJSON(value.statutInscription),
        'sortKey': value.sortKey,
        'aggregateKeys': value.aggregateKeys === undefined ? undefined : (value.aggregateKeys === null ? null : (value.aggregateKeys as Array<any>).map(AggregateKeyInfoToJSON)),
        'forceSkip': value.forceSkip,
        'forceTake': value.forceTake,
        'parameters': value.parameters,
        'filter': value.filter,
    };
}

